module.exports = __webpack_public_path__ + "img/2-5.3286e31c.svg";